import React from 'react';

import { Trans } from '@lyearn/i18n';
import { ClockOutline } from '@lyearn/icons';
import { SidebarEmptyState } from '@lyearn/molecules';
import { Timeline } from '@lyearn/ui';
import Loader from '@/components/Loader';
import VirtualizedList from '@/components/VirtualizedList';
import { ResourceVersionTypeEnum } from '@/types/schema';

import HistoryTimelineItem from './TimelineItem';
import { DialogContentProps } from './types';

const DialogContent: React.FC<DialogContentProps> = ({
  versionsHistory,
  fetchMore,
  initialFetching,
}) => {
  if (initialFetching) {
    return <Loader showLabel={false} />;
  }

  if (!versionsHistory?.length) {
    return (
      <SidebarEmptyState
        Icon={ClockOutline}
        className="-mt-48 flex-1"
        description={<Trans i18nKey="Admin:VersionHistory.EmptyStateDescription" />}
      />
    );
  }

  return (
    <Timeline className="mt-12 p-0">
      <VirtualizedList
        data={versionsHistory}
        endReached={fetchMore}
        itemContent={(index) => {
          const { versionNumber, id, note, type, createdBy, createdAt } = versionsHistory[index];

          return (
            <HistoryTimelineItem
              key={id}
              createdAt={createdAt}
              isFirstItem={index === 0}
              isLastItem={versionNumber === '1.0' && type === ResourceVersionTypeEnum.Major}
              note={note}
              type={type as ResourceVersionTypeEnum}
              userName={createdBy?.name}
              versionNumber={versionNumber}
            />
          );
        }}
      />
    </Timeline>
  );
};

export default DialogContent;
